module.exports = __webpack_public_path__ + "img/first-time.afe57543.svg";